/*
 * @Description: user module
 * @Date: 2020-07-14 17:18:26
 * @LastEditTime: 2020-11-23 21:05:36
 */
import {
    setToken,
    getToken,
    removeToken
} from '@/utils/auth.js'
// import {
//     appList
// } from "@/api/app.js";
import {
    loginIn,
} from '@/api/user.js'
import {
    resetRouter
} from '@/router'

const getDefaultState = () => {
    return {
        token: getToken(),
        name: '',
        showModel: false
    }
}

const state = getDefaultState()
const mutations = {
    RESET_STATE: (state) => {
        Object.assign(state, getDefaultState())
    },
    SET_TOKEN: (state, token) => {
        state.token = token
    },
    SET_NAME: (state, name) => {
        state.name = name
    },
    SET_MENU: (state, menus) => {
        state.menus = menus
    },
    SET_MODEL: (state, value) => {
        state.showModel = value
    }
}

const actions = {
    login({
        commit
    }, userInfo) {
        return new Promise((resolve, reject) => {
            loginIn(userInfo).then(res => {
                let _token = res.access
                commit('SET_TOKEN', _token)
                localStorage.setItem('project_id', res.user.project_id)
                localStorage.setItem('company_id', res.user.company_id)
                localStorage.setItem('user', res.user.username)
                // appList({project_id: localStorage.getItem('project_id')}).then(resp => {
                //     localStorage.setItem('appList', JSON.stringify(resp))
                // })
                setToken(_token)
                resolve()
            }).catch(err => {
                reject(err)
            })
        })

    },
    logout({
        commit
    }) {
        return new Promise((resolve) => {
            localStorage.removeItem("curAppId")
            localStorage.removeItem("curApp")
            localStorage.removeItem("company_id")
            localStorage.removeItem("project_id")
            localStorage.removeItem("appList")

            removeToken()
            commit('RESET_STATE')
            resetRouter()
            resolve()
        })
    }
}
export default {
    namespaced: true,
    state,
    mutations,
    actions
}